import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ControlService } from 'src/app/shared/control.service';

@Component({
  selector: 'app-players',
  templateUrl: './players.component.html',
  styleUrls: ['./players.component.scss']
})
export class PlayersComponent implements OnInit {
  form: FormGroup;
  players: string[] = [];

  constructor(private router: Router, private formBuilder: FormBuilder, private controlService: ControlService) {
    this.players = this.controlService.players;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: [null],
    });
  }

  removePlayer(index: number) {
    this.players.splice(index, 1);
  }

  addPlayer(form) {
    if (form.name) {
      this.players.push(form.name);
      this.form.get('name').setValue('');
    }
  }

  next(): void {
    this.controlService.players = this.players;
    this.router.navigate(['/', 'collections']);
  }
}
